import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=d7748f0a"
import script from "./UploadButton.vue?vue&type=script&lang=ts"
export * from "./UploadButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7748f0a')) {
      api.createRecord('d7748f0a', component.options)
    } else {
      api.reload('d7748f0a', component.options)
    }
    module.hot.accept("./UploadButton.vue?vue&type=template&id=d7748f0a", function () {
      api.rerender('d7748f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/generic/UploadButton.vue"
export default component.exports